import { generateClient } from "aws-amplify/api";

const client = generateClient();

import { list_blogs } from '@/graphql/queries'

export default {
  data() {
    return {
      BlogPostsList: [],
    }
  },
  methods: {
    async fetchBlogPosts() {
      try {
        const response = await client.graphql({
          query: list_blogs,
          variables: {
            input: { 
              blog_status:'ALL'
            }
          }
        })
        let responseData = JSON.parse(response.data.list_blogs)
        // console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.BlogPostsList = responseData.data || []
        } else {
          this.BlogPostsList = []
        }
        // console.log(this.BlogPostsList)
      } catch (error) {
        console.error("Error fetching Testimonials:", error);
        this.BlogPostsList = [];
        throw error;
      }
    },
  },
};
